import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; // ✅ Import Link

const Features = () => {
  useEffect(() => {
    const Swiper = window.Swiper;

    if (Swiper) {
      new Swiper('.categorySlider', {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        breakpoints: {
          0: { slidesPerView: 1 },
          576: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 3 },
          1400: { slidesPerView: 5, spaceBetween: 45 },
        },
      });
    }
  }, []);

  return (
    <section
      className="category-area bg-top-center space"
      data-bg-src="assets/img/bg/category_bg_1.png"
    >
      <div className="container th-container">
        <div className="title-area mb-60 text-center">
          <span className="sub-title text-anime-style-2">Our Features</span>
          <h2 className="sec-title text-anime-style-3">
            Reliable IT for Unstoppable Growth
          </h2>
        </div>

        {/* Swiper Slider */}
        <div className="swiper categorySlider">
          <div className="swiper-wrapper">
            {[
              {
                img: 'category_1_1.jpg',
                title: 'Enhanced Cybersecurity',
                text: 'Advanced security measures like firewalls, encryption,',
              },
              {
                img: 'category_1_2.jpg',
                title: 'Cloud Integration',
                text: 'Access to scalable cloud-based services for storage',
              },
              {
                img: 'category_1_3.jpg',
                title: 'Customized Services',
                text: 'Tailored IT solutions designed to meet specific business needs.',
              },
              {
                img: 'category_1_4.jpg',
                title: '24/7 IT Support',
                text: 'Around-the-clock monitoring and troubleshooting.',
              },
              {
                img: 'category_1_5.jpg',
                title: 'End-to-End Solution',
                text: 'Covers all aspects of IT, from consulting and planning',
              },
            ].map((item, index) => (
              <div className="swiper-slide" key={index}>
                <div className="category-card single">
                  <div className="box-img global-img">
                    <img
                      src={`assets/img/category/${item.img}`}
                      alt={item.title}
                    />
                  </div>
                  <h3 className="box-title">
                    <Link to="/services">{item.title}</Link> {/* ✅ Replaced <a> with <Link> */}
                  </h3>
                  <p className="sec-text">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
